function cloudinaryUrl(url, { width, quality = 85, format = 'auto' } = {}) {
  if (!url || !url.includes('cloudinary.com')) return url;
  const parts = [
    `f_${format}`,
    `q_${quality}`,
    width ? `w_${width},c_scale` : null,
  ].filter(Boolean).join(',');
  return url.replace(/\/upload\/(?!.*\/upload\/)/, `/upload/${parts}/`);
}

module.exports = { cloudinaryUrl };
